export const selectIsFetchingSAPLog = (state) => state.sapLog.isFetching
export const selectSAPLogData = (state) => state.sapLog.data.list
export const selectShouldShowSAPLogView = (state) => state.sapLog.data.shouldShowLogView
